import React from 'react';
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Stack,
  useTheme,
  alpha,
} from '@mui/material';
import RecordVoiceOverOutlinedIcon from '@mui/icons-material/RecordVoiceOverOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const LANGUAGES = [
  { code: 'de', label: 'Deutsch (de)' },
  { code: 'en', label: 'Englisch (en)' },
  { code: 'fr', label: 'Französisch (fr)' },
  { code: 'es', label: 'Spanisch (es)' },
  { code: 'it', label: 'Italienisch (it)' },
  { code: 'nl', label: 'Niederländisch (nl)' },
  { code: 'ru', label: 'Russisch (ru)' },
];

export default function TranscriptionSettings({
  language,
  onLanguageChange,
  disabled,
}) {
  const theme = useTheme();
  return (
    <Stack spacing={2}>
      <Box>
        <FormControl sx={{ maxWidth: 260, width: '100%' }} size="small">
          <InputLabel>Sprache</InputLabel>
          <Select
            value={language}
            onChange={(e) => onLanguageChange(e.target.value)}
            label="Sprache"
            disabled={disabled}
          >
            {LANGUAGES.map((l) => (
              <MenuItem key={l.code} value={l.code}>
                {l.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Stack
          direction="row"
          spacing={0.75}
          alignItems="flex-start"
          sx={{ mt: 1 }}
        >
          <InfoOutlinedIcon
            sx={{ fontSize: 16, color: 'text.secondary', mt: '2px' }}
          />
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ lineHeight: 1.45 }}
          >
            Eine Sprache pro Datei — mehrsprachige Audios werden in die
            gewählte Sprache transkribiert.
          </Typography>
        </Stack>
      </Box>

      <Box
        sx={{
          p: 1.5,
          borderRadius: 2,
          bgcolor: alpha(theme.palette.primary.main, 0.08),
          border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center" mb={0.5}>
          <RecordVoiceOverOutlinedIcon fontSize="small" color="primary" />
          <Typography
            sx={{ fontSize: '0.85rem', fontWeight: 600 }}
            color="primary.main"
          >
            Sprechererkennung immer aktiv
          </Typography>
        </Stack>
        <Typography variant="caption" color="text.secondary" component="div">
          • Automatische Erkennung verschiedener Sprecher
        </Typography>
        <Typography variant="caption" color="text.secondary" component="div">
          • Wort-für-Wort Zeitmarken für präzises Springen im Audio
        </Typography>
        <Typography variant="caption" color="text.secondary" component="div">
          • Sprecher können nach der Transkription benannt werden
        </Typography>
      </Box>
    </Stack>
  );
}
